const NL = {
  toCart: 'naar winkelwagen',
  continue: 'verder winkelen'
}
const FR = {
  toCart: 'finaliser mes achats',
  continue: 'continuer mes achats'
}

const translations = {
  nl: NL,
  fr: FR
}

export const t = (key, lang) => translations[lang]?.[key] || translations.nl[key] || key
